import App from './application-container';
import * as THREE from 'three';
import { hide_modal } from './modals';
import { in_tutorial, model_is_dirty } from './state';
import { set_shift } from './keypress';
import { create_scene_node, reset_scene_node } from '@phi/util/object3d';
import { curvature_raynode } from '../../../../src/features/curvature-combs';
import { frontend_service_container } from '@phi/frontend/service-container';

export function setup_event_handlers() {
  window.addEventListener("focus", function (e) {handle_onfocus(e);}, false);

  // Add event listener for unloading page.
  window.addEventListener("beforeunload", async function(e) {
    // Don't do it if in a tutorial stage.
    if (!model_is_dirty() || in_tutorial())
        return true;

    if (App.state.framework === 'onshape') {
        await frontend_service_container().saving_loading.onshape_autosave();
    }

    return true;
  });

  var canvas = document.getElementById("scene-container");
  canvas.addEventListener("webglcontextlost", function(event) {
    console_log_xml("LOST CONTEXT");
    event.preventDefault();
  }, false);
}

export function handle_onfocus(e) { set_shift(false); }

export function bring_up_select_item_dialog(dialog_usage, close_modals = true) {
  //console.log("In bring_up_select_item_dialog.");
  if (close_modals)
    hide_modal("selectModelModal");

  if (dialog_usage == "import_model_from_onshape") {
    onshape_selectItemDialog_usage = "import_model_from_onshape";

    console_log("Selecting for import_model_from_onshape");
    var message = {documentId: onshape_document_id,
      workspaceId: onshape_workspace_id,
      elementId: onshape_element_id,
      messageName: 'openSelectItemDialog',
      dialogTitle: 'Select a Part Studio',
      selectPartStudios: true,
      selectParts: true
        /*
        selectBlobs: true or false (default is false),
        selectParts: true or false (default is false),
        selectPartStudios: true or false (default is false),
        selectAssemblies: true or false (default is false),
        selectMultiple: true or false (default is false),
        selectBlobMimeTypes: ‘comma-delimited string of blob mime types to show in dialog
        (e.g. “application/dwt,application/dwg”)’ (default is an empty string)
        showBrowseDocuments: true or false - controls whether ‘Other documents’ choice should be available (default is true)
        showStandardContent: true or false - controls whether ‘Standard content’ choice should be available (default is false)
        */
    };
  }

  else if (dialog_usage == "import_ref_model_from_onshape") {
    onshape_selectItemDialog_usage = "import_ref_model_from_onshape";

    console_log("Selecting for import_ref_model_from_onshape");
    var message = {documentId: onshape_document_id,
      workspaceId: onshape_workspace_id,
      elementId: onshape_element_id,
      messageName: 'openSelectItemDialog',
      dialogTitle: 'Select a Part Studio',
      selectPartStudios: true,
      selectParts: true
        /*
        selectBlobs: true or false (default is false),
        selectParts: true or false (default is false),
        selectPartStudios: true or false (default is false),
        selectAssemblies: true or false (default is false),
        selectMultiple: true or false (default is false),
        selectBlobMimeTypes: ‘comma-delimited string of blob mime types to show in dialog
        (e.g. “application/dwt,application/dwg”)’ (default is an empty string)
        showBrowseDocuments: true or false - controls whether ‘Other documents’ choice should be available (default is true)
        showStandardContent: true or false - controls whether ‘Standard content’ choice should be available (default is false)
        */
    };
  }
  window.parent.postMessage(message, '*');
  //console.log("Posted openSelectItemDialog message.");
  //console.log(message);
}

export function create_scene_nodes() {
  // Create scene nodes and place them under the scene

  // All geometries (phi and reference) go under one node:
  uid_geometries_raynode = create_scene_node("uid_geometries_raynode");
  scene.add(uid_geometries_raynode)

  uid_objects_raynode = create_scene_node("uid_objects_raynode");
  uid_geometries_raynode.add(uid_objects_raynode);

  uid_reference_raynode = create_scene_node("uid_reference_raynode");
  uid_geometries_raynode.add(uid_reference_raynode);

  uid_reference_stl_raynode = create_scene_node("uid_reference_stl_raynode");
  uid_reference_raynode.add(uid_reference_stl_raynode);

  uid_reference_parasolid_raynode = create_scene_node("uid_reference_parasolid_raynode");
  uid_reference_raynode.add(uid_reference_parasolid_raynode);

  uid_reference_partstudio_raynode = create_scene_node("uid_reference_partstudio_raynode");
  uid_reference_raynode.add(uid_reference_partstudio_raynode);

  uid_ref_stl_vertex_raynode = create_scene_node("uid_ref_stl_vertex_raynode");
  uid_ref_stl_faces_raynode = create_scene_node("uid_ref_stl_faces_raynode");
  uid_ref_stl_edges_raynode = create_scene_node("uid_ref_stl_edges_raynode");
  uid_ref_partstudio_vertex_raynode = create_scene_node("uid_ref_partstudio_vertex_raynode");
  uid_ref_partstudio_faces_raynode = create_scene_node("uid_ref_partstudio_faces_raynode");
  uid_ref_partstudio_edges_raynode = create_scene_node("uid_ref_partstudio_edges_raynode");
  uid_ref_parasolid_vertex_raynode = create_scene_node("uid_ref_parasolid_vertex_raynode");
  uid_ref_parasolid_faces_raynode = create_scene_node("uid_ref_parasolid_faces_raynode");
  uid_ref_parasolid_edges_raynode = create_scene_node("uid_ref_parasolid_edges_raynode");


  uid_ref_faces_for_attaching_surface_raynode = create_scene_node("uid_ref_faces_for_attaching_surface_raynode");

  uid_visible_edge_mesh_raynode = create_scene_node("uid_visible_edge_mesh_raynode");
  scene.add(uid_visible_edge_mesh_raynode);

  uid_ref_stl_edges_visible_raynode = create_scene_node("uid_ref_stl_edges_visible_raynode");
  uid_ref_partstudio_edges_visible_raynode = create_scene_node("uid_ref_partstudio_edges_visible_raynode");

  uid_manip_raynode = create_scene_node("uid_manip_raynode");
  scene.add(uid_manip_raynode);
  uid_manip_aux_raynode = create_scene_node("uid_manip_aux_raynode");
  scene.add(uid_manip_aux_raynode);
  uid_grid_raynode = create_scene_node("uid_grid_raynode");
  uid_working_plane_raynode = create_scene_node("uid_working_plane_raynode");
  uid_halo_raynode = create_scene_node("uid_halo_raynode");
  uid_selection_box_raynode = create_scene_node("uid_selection_box_raynode");
  uid_text_raynode = create_scene_node("uid_text_raynode");
  scene.add(uid_text_raynode);
  uid_debug_obj_raynode = create_scene_node("uid_debug_obj_raynode");
  scene.add(uid_debug_obj_raynode);
  uid_draw_edge_raynode = create_scene_node("uid_draw_edge_raynode");
  scene.add(uid_draw_edge_raynode);
  uid_rotation_center_raynode = create_scene_node("uid_rotation_center_raynode");
  scene.add(uid_rotation_center_raynode);
  uid_glow_raynode = create_scene_node("uid_glow_raynode");
  scene.add(uid_glow_raynode);
  uid_aux_ball_disk_raynode = create_scene_node("uid_aux_ball_disk_raynode");
  scene.add(uid_aux_ball_disk_raynode);
  uid_axes_raynode = create_scene_node("uid_axes_raynode");
  uid_axes_planes_raynode = create_scene_node("uid_axes_planes_raynode");
  uid_symmetry_plane_raynode = create_scene_node("uid_symmetry_plane_raynode");
  uid_mirror_plane_raynode = create_scene_node("uid_mirror_plane_raynode");
  uid_shadow_plane_raynode = create_scene_node("uid_shadow_plane_raynode");
  uid_sketch_plane_raynode = create_scene_node("uid_sketch_plane_raynode");
  scene.add(uid_sketch_plane_raynode);
  uid_deleted_sketch_plane_raynode = create_scene_node("uid_deleted_sketch_plane_raynode");
  uid_sketch_objects_raynode = create_scene_node("uid_sketch_objects_raynode");
  scene.add(uid_sketch_objects_raynode);
  uid_hidden_sketch_plane_raynode = create_scene_node("uid_hidden_sketch_plane_raynode");
  uid_hidden_sketch_objects_raynode = create_scene_node("uid_hidden_sketch_objects_raynode");
  uid_temporary_node_for_sketch_raynode = create_scene_node("uid_temporary_node_for_sketch_raynode");
  scene.add(uid_temporary_node_for_sketch_raynode);
  uid_lights_raynode = create_scene_node("uid_lights_raynode");
  scene.add(uid_lights_raynode);
  reset_scene_node(curvature_raynode);
  uid_clipping_planes_raynode = create_scene_node("uid_clipping_planes_raynode");
  uid_tangent_display_raynode = create_scene_node("uid_tangent_display_raynode");
  uid_edge_midpoint_raynode = create_scene_node("uid_edge_midpoint_raynode");
  initialize_edge_midpoint_node();
}

export function initialize_edge_midpoint_node() {
  var em_material = new THREE.MeshBasicMaterial({ color: 0xaaaaaa });
  em_material.side = THREE.DoubleSide;
  em_material.transparent = true;
  em_material.opacity = 0.8;
  em_material.depthTest = false;
  em_material.depthWrite = false;
  uid_edge_midpoint_section_nodes = [];

  const em_geometry_1 = new THREE.BoxGeometry(1, 1, 1);
  var uid_edge_midpoint_section_node_1 = new THREE.Mesh(em_geometry_1, em_material);
  uid_edge_midpoint_section_node_1.name = "edge_midpoint_1";
  uid_edge_midpoint_raynode.add(uid_edge_midpoint_section_node_1);
  uid_edge_midpoint_section_nodes.push(uid_edge_midpoint_section_node_1);

  const em_geometry_2 = new THREE.BoxGeometry(1, 1, 1);
  var uid_edge_midpoint_section_node_2 = new THREE.Mesh(em_geometry_2, em_material);
  uid_edge_midpoint_section_node_2.name = "edge_midpoint_2";
  uid_edge_midpoint_raynode.add(uid_edge_midpoint_section_node_2);
  uid_edge_midpoint_section_nodes.push(uid_edge_midpoint_section_node_2);

  const em_geometry_3 = new THREE.BoxGeometry(1, 1, 1);
  var uid_edge_midpoint_section_node_3 = new THREE.Mesh(em_geometry_3, em_material);
  uid_edge_midpoint_section_node_3.name = "edge_midpoint_3";
  uid_edge_midpoint_raynode.add(uid_edge_midpoint_section_node_3);
  uid_edge_midpoint_section_nodes.push(uid_edge_midpoint_section_node_3);

  const em_geometry_4 = new THREE.BoxGeometry(1, 1, 1);
  var uid_edge_midpoint_section_node_4 = new THREE.Mesh(em_geometry_4, em_material);
  uid_edge_midpoint_section_node_4.name = "edge_midpoint_4";
  uid_edge_midpoint_raynode.add(uid_edge_midpoint_section_node_4);
  uid_edge_midpoint_section_nodes.push(uid_edge_midpoint_section_node_4);

  const em_geometry_5 = new THREE.BoxGeometry(1, 1, 1);
  var uid_edge_midpoint_section_node_5 = new THREE.Mesh(em_geometry_5, em_material);
  uid_edge_midpoint_section_node_5.name = "edge_midpoint_5";
  uid_edge_midpoint_raynode.add(uid_edge_midpoint_section_node_5);
  uid_edge_midpoint_section_nodes.push(uid_edge_midpoint_section_node_5);

  const em_geometry_6 = new THREE.BoxGeometry(1, 1, 1);
  var uid_edge_midpoint_section_node_6 = new THREE.Mesh(em_geometry_6, em_material);
  uid_edge_midpoint_section_node_6.name = "edge_midpoint_6";
  uid_edge_midpoint_raynode.add(uid_edge_midpoint_section_node_6);
  uid_edge_midpoint_section_nodes.push(uid_edge_midpoint_section_node_6);

  const em_geometry_7 = new THREE.BoxGeometry(1, 1, 1);
  var uid_edge_midpoint_section_node_7 = new THREE.Mesh(em_geometry_7, em_material);
  uid_edge_midpoint_section_node_7.name = "edge_midpoint_7";
  uid_edge_midpoint_raynode.add(uid_edge_midpoint_section_node_7);
  uid_edge_midpoint_section_nodes.push(uid_edge_midpoint_section_node_7);
}


export function create_camera_and_camera_controls() {
  uid_camera = new THREE.OrthographicCamera( (-aspectRatio * viewSize) / 2, (aspectRatio * viewSize) / 2, viewSize / 2, -viewSize / 2, 0, 80 );
  // uid_camera = new THREE.PerspectiveCamera( 45, aspectRatio, 1, 1000 );

  // Create the uid_raycaster
  uid_raycaster = new THREE.Raycaster();
  uid_raycaster.params.Line.threshold = viewSize/uid_raycaster_line_precision_factor;
}

export function handle_tutorial_state() {
  $(document.body).addClass("tutorial");
  $(document.body).addClass("aside");
  switch (App.state.tut_stage) {
    case 1:
      $('body').addClass("tutorial--step-1");
    break;
    case 2:
      $('body').addClass("tutorial--step-2");
    break;
    case 3:
      $('body').addClass("tutorial--step-3");
    break;
    case 4:
      $('body').addClass("tutorial--step-4");
    break;
    case 5:
      $('body').addClass("tutorial--step-5");
    break;
  }
}

export function resizeDiv() {
  if (!renderer) return;
  var c = document.getElementById('container-parent');
  const rect = c.getBoundingClientRect();
  const width = Math.floor(rect.width);
  const height = Math.floor(rect.height);
  renderer.setSize(width, height);
  console_log("Rendered set width:", width);
  console_log("Rendered set height:", height);
}

export function preparatory_work() {
  $("#xml-img").attr("src", img_xml_active_png);
  $("#do-magic-img").attr("src", img_do_magic_active_png);
  $("#vars-img").attr("src", img_vars_active_png);
  $("#step").attr("src", img_step_png);
  $("#step1").attr("src", img_step_png);
  $("#stl-icon").attr("src", img_stl_file_icon_png);
  $("#stlExport").attr("src", img_stl_file_icon_png);
  $("#3dprint").attr("src", img_3dprint_png);
  $("#3dscan").attr("src", img_3dscan_png);
  $("#phenoworld").attr("src", img_phenoworld_png);
  $("#phenoprint").attr("src", img_phenoprint_png);
  $("#onshape").attr("src", img_onshape_logo_png);
  $("#onshapePartStudio").attr("src", img_onshape_logo_png);
  $("#onshapeSave").attr("src", img_onshape_logo_png);
  $("#fileSave").attr("src", img_save_file_png);
  $("#upload-img-large").attr("src", img_upload_large_icon_png);
  $("#isomaterial").attr("src", img_isomaterial_png);
  $("#reflectioncastle").attr("src", img_reflectioncastle_png);
  $("#reflectioniso").attr("src", img_reflectioniso_png);
  $("#philogo_img").attr("src", img_philogo_png);
  $("#phenometrylogo_img").attr("src", img_phenometrylogo_png);
  $("#tutorials").attr("src", img_tutorials_png);

  resizeDiv();
}
